import { Component, Inject, Input, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UniversoAuditavelService } from "../../../../services/universo-auditavel.service";
import { SharedService } from "../../../../services/shared.service";
import Swal from "sweetalert2";
import { IPlanejamentoPapelTrabalho } from "src/app/models/planejamento-papel-trabalho.model";

@Component({
	selector: 'app-modal-papel-nao-cadastrado',
	templateUrl: './modal-papel-nao-cadastrado.component.html',
	styleUrls: ['./modal-papel-nao-cadastrado.component.scss'],
})

export class ModalPapelNaoCadastradoComponent implements OnInit {

  	novoItem: string = '';

	constructor(
		private router: Router,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private universoAuditavelService: UniversoAuditavelService,
		private sharedService: SharedService,
		private dialogRef: MatDialogRef<ModalPapelNaoCadastradoComponent>
	) {}

	ngOnInit(): void {}

	cancelar(): void {
		this.dialogRef.close();
	}

	salvar(): void {
		if (this.novoItem.length > 100) {
			this.mensagem("O nome do Papel de Trabalho não pode ter mais de 100 caracteres!");
			return;
		}

		// if (this.data.listPapeis.some(s => s.nomePapel == this.novoItem)) {
		// 	this.mensagem("Este nome de Papel de Trabalho já está sendo usado!");
		// 	return;
		// }

		this.dialogRef.close(this.novoItem);
	}

	mensagem(msg: string) {
		Swal.fire({
			toast: true,
			position: "top-end",
			icon: "warning",
			html: msg,
			showConfirmButton: false,
			showCloseButton: true,
			title: "",
		});
	}
}
